import {
  CardDefinition,
  CAROUSEL,
  CarouselDefinition,
  CarouselNextDefinition,
  CAROUSEL_NEXT,
  CAROUSEL_BACK
} from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { CarouselBacktDefinition } from '~/training/sequence/templates/items/carousel-back/CarouselBack';
import { useEditorStore } from '~/shell/Store';
import { OPTIONAL_TEXT_FIELDS } from '../utils/optionalFields';

export const Cards2: Translator = sequence => {
  const { editorMode } = useEditorStore.getState();
  const cards: CardDefinition[] = [];
  const cardCount =
    sequence.items?.filter(i => i.__typename === 'Card').length || 0;
  let cardIndex = 1;
  const carouselId = `${sequence.id}.carousel`;
  const root = translate(
    sequence,
    item => {
      if (item.__typename === 'Card') {
        const extraItems = [];

        extraItems.push({
          id: `${item.id}.next`,
          type: CAROUSEL_NEXT,
          values: { carouselId },
          items: []
        } as CarouselNextDefinition);

        if (cardIndex > 1) {
          extraItems.push({
            id: `${item.id}.back`,
            type: CAROUSEL_BACK,
            values: { carouselId },
            items: []
          } as CarouselBacktDefinition);
        }

        cards.push(
          CardHelper(item as ItemOfType<'Card'>, {
            height: 'unset',
            titlePadding: { _: '20px 0px', md: '10px 10px 10px 0px' },
            width: { _: '230px', sm: '300px' },
            padding: !editorMode
              ? cardIndex > 1
                ? '30px 0px 0px 0px'
                : '0px'
              : '0px',
            className: 'cardStyleForDarkTheme',
            optional: OPTIONAL_TEXT_FIELDS,
            extraItems: editorMode
              ? []
              : cardIndex === cardCount
                ? [
                    {
                      id: `${item.id}.back`,
                      type: CAROUSEL_BACK,
                      values: { carouselId },
                      items: []
                    } as CarouselBacktDefinition
                  ]
                : extraItems
          })
        );
        cardIndex++;
      }

      return null;
    },
    sequence.personalization
  );

  //PRD-238 we need to remove fixed height for learner side, because we have overflow: auto in the card
  root.items.push({
    type: CAROUSEL,
    id: `${sequence.id}.carousel`,
    values: {
      variant: editorMode ? 'horizontal' : 'stack',
      cssStylesForItem: editorMode
        ? {
            display: 'flex',
            height: '80%',
            minHeight: '480px'
          }
        : undefined,
      newItemFields: {
        title: 'Type Here',
        body: 'Type Here'
      }
    },
    items: cards
  } as CarouselDefinition);

  return root;
};
